export default __webpack_public_path__ + "static/media/enyaq.20211942.png";